import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceParams } from "@refinedev/core";
import { useOne } from "@/hooks";
import { Card, Row, Col, Input, Switch, Typography } from 'antd';
import { useTranslation } from "react-i18next";

const { TextArea } = Input;
const { Text } = Typography;
export const VersionDetailPanel = () => {
  const { t } = useTranslation();
  const { state } = useResourceContext();
  const { action } = useResourceParams();
  const isList = action === "list";
  const isShow = action === "show";
  const selected = (isList || isShow) && state.selectedResources[0];
  const { data, isLoading } = useOne({
    resource: "versionSettings",
    id: action === "list" ? selected?.sprint : null,
    skip: isList && !selected,
  });
  let loading = isList ? false : isLoading;
  let instance = selected ? (isList ? data || selected : data) : null;

  return (
    <div>
      {loading && <div>Loading...</div>}
      {instance && 
    <Card style={{ width: 900, minHeight: 200, marginTop: 0 }}>
      <Row align="top">
        <Col flex="300px">
          <Row align="middle" style={{ marginBottom: 8 }}>
            <Col span={10} ><Text strong>Version</Text></Col>
            <Col span={14}>{instance.sprint}</Col>
          </Row>

          <Row align="middle" style={{ marginBottom: 8 }}>
            <Col span={10} ><Text strong>Image version</Text></Col>
            <Col span={14}>{instance.aiops_image_version}</Col>
          </Row>

          <Row align="middle" style={{ marginBottom: 8 }}>
            <Col span={10} ><Text strong>Platform</Text></Col>
            <Col span={14}>{instance.viaops_image_version}</Col>
          </Row>

          <Row align="middle" style={{ marginBottom: 8 }}>
            <Col span={10}><Text strong>LTS</Text></Col>
            <Col span={14}>
              <Switch
                checked={instance.lts}
                checkedChildren="ON"
                unCheckedChildren="OFF"
                disabled
              />
            </Col>
          </Row>
        </Col>
        <Col flex="auto" align="top">
          <Row style={{ marginBottom: 8 }} align="top">
            <Col span={6} ><Text strong>Modules</Text></Col>
            <Col span={18}>
              <TextArea value={instance.included_modules} readOnly rows={3} style={{width:"100%",height:"100%", resize:"none"}}/>          
            </Col>
          </Row>
          <Row style={{ marginBottom: 8 }} align="top">
            <Col span={6} ><Text strong>Optional modules</Text></Col>
            <Col span={18}>{instance.optional_modules}</Col>
          </Row>
          <Row style={{ marginBottom: 8 }} align="top">
            <Col span={6} ><Text strong>Upgrade from</Text></Col>
            <Col span={18}>
              <TextArea value={instance.upgrade_from} readOnly rows={2} style={{width:"100%",height:"100%", resize:"none"}}/>          
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>}
    </div>
  );

};
